import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import {
  ThumbUpAltOutlined as ThumbUpIcon,
  ThumbDownAltOutlined as ThumbDownIcon,
  ThumbUpAlt as ThumbUpAltIcon,
  ThumbDownAlt as ThumbDownAltIcon,
} from '@mui/icons-material';
import { Colors } from '../assets/theme/Colors';

const DonorLinkPickupIndicator = ({ pickupReady, isMobile }) => {
  const iconSx = {
    color: Colors.white,
  };

  // Mobile
  if (isMobile) {
    if (pickupReady) {
      return (
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
          <ThumbUpAltIcon sx={{ color: Colors.green.main }} />
          <Typography variant="caption" sx={{ color: Colors.green.main, textAlign: 'center' }}>
            Pickup Ready!
          </Typography>
        </Box>
      );
    }

    return (
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <ThumbDownAltIcon sx={{ color: Colors.red }} />
        <Typography variant="caption" sx={{ color: Colors.red, textAlign: 'center' }}>
          No food yet!
        </Typography>
      </Box>
    );
  }

  // Desktop
  if (pickupReady) {
    return (
      <Tooltip title="Pickup is a go!">
        <Box
          display="flex"
          alignItems="center"
          sx={{ borderRadius: '5px', padding: '1px', backgroundColor: Colors.green.main, maxWidth: 'max-content' }}
        >
          <ThumbUpIcon sx={iconSx} />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="No food yet!">
      <Box
        display="flex"
        alignItems="center"
        sx={{ borderRadius: '5px', padding: '1px', backgroundColor: Colors.red, maxWidth: 'max-content' }}
      >
        <ThumbDownIcon sx={iconSx} />
      </Box>
    </Tooltip>
  );
};

export default DonorLinkPickupIndicator;
